<form [formGroup]="borrowerAddressForm">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 form-group d-flex flex-column">
          <p-panel class="secondary-panel">
            <ng-template pTemplate="header">
              <div class="d-flex justify-content-between align-items-center flex-fill">
                <span>Present Address</span>
                @if (!formDisabled && isBorrowerEnabled && !borrower?.isPrimaryBorrower) {
                  <p-button
                    class="mb-0"
                    styleClass="p-button-link h-auto p-0"
                    label="Copy from Borrower"
                    (click)="onCopyAddress(BorrowerAddressTypes.Present)"
                  />
                }
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <cmg-borrower-address-child
                #presentAddress
                formControlName="presentAddress"
                [context]="borrower?.isPrimaryBorrower ? 'Borrower\'s Present Address' : 'Additional Borrower\'s Present Address'"
                [autoIdPrefix]="autoIdPrefix() + 'presentAddress-'"
                [addressType]="BorrowerAddressTypes.Present"
                [borrowerId]="borrower?.borrowerId"
              />
            </ng-template>
          </p-panel>
        </div>
      </div>
    </div>
  </div>
</form>
